import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';
import { errorToast, isValidEmail } from '../../utils';
import { registerUser } from '../../store/auth/authActions';

export const RegisterForm = () => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.auth);
    const [validationError, setValidationError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    let firstName = useRef('');
    let lastName = useRef('');
    let email = useRef('');
    let password = useRef('');

    const signUpUser = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (
            !firstName.value.trim()
            || !lastName.value.trim()
            || !email.value.trim()
            || !password.value.trim()
        ) {
            setValidationError('All fields are required');
        } else if (!isValidEmail(email.value)) {
            setValidationError('Please enter a valid email address');
        } else {
            if(password.value.trim().length < 8){
                setShowError(true);
                return;
            }
            if(loading) return;
            dispatch(registerUser({
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
                password: password.value,
            }))
                .unwrap()
                .catch((errorData) => {
                    errorToast(errorData.error);
                });
        }
    };

    return (
        <form onSubmit={signUpUser} className='space-y-4'>
            <div>
                <h1 className='mb-1 text-center text-nt-blue'>Create Account</h1>
                <p className='text-center text-sm text-nt-grey'>Join Ioparla and start learning with expert tutors.</p>
            </div>

            <div>
                <label className="block text-primary-grey text-[13px] font-medium pb-1">First Name</label>
                <div className="relative">
                    <input
                        className="nt-auth-input"
                        name="firstName"
                        placeholder="Enter your first name"
                        id="firstName"
                        onChange={() => setValidationError('')}
                        ref={(e) => { firstName = e; }}
                        type="text"
                        required />
                </div>
            </div>
            <div>
                <label className="block text-primary-grey text-[13px] font-medium pb-1">Last Name</label>
                <div className="relative">
                    <input
                        className="nt-auth-input"
                        name="lastName"
                        placeholder="Enter your last name"
                        id="lastName"
                        onChange={() => setValidationError('')}
                        ref={(e) => { lastName = e; }}
                        type="text"
                        required />
                </div>
            </div>
            <div>
                <label className="block text-primary-grey text-[13px] font-medium pb-1">Email</label>
                <div className="relative">
                    <input
                        className="nt-auth-input"
                        name="email"
                        placeholder="Enter your email"
                        id="email"
                        onChange={() => setValidationError('')}
                        ref={(e) => { email = e; }}
                        type="email"
                        required />
                </div>
            </div>
            <div>
                <div className="mb-1 flex items-center justify-between">
                    <label className="block text-[13px] font-medium text-primary-grey">Password</label>
                    <span className='text-[11px] text-slate-400'>At least 8 characters</span>
                </div>
                <div className="relative">
                    <input
                        className="nt-auth-input pr-11"
                        name="password"
                        placeholder="Enter your password"
                        id="password"
                        onChange={() => {setValidationError(''); setShowError(false)}}
                        ref={(e) => { password = e; }}
                        type={showPassword ? 'text' : 'password'}
                        required />
                    <button
                        type="button"
                        className="nt-auth-eye-btn"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        title={showPassword ? "Hide password" : "Show password"}
                    >
                        {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                    </button>
                </div>
                {showError ? <span className='mt-1 block text-xs text-nt-red'>The password must be at least 8 characters long</span>: ""}
            </div>
            {validationError && <p className="text-left text-sm text-red">{validationError}</p>}
            <button type="submit" className="w-full rounded-xl bg-nt-blue px-4 py-2.5 text-white transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-70" disabled={loading}>
                {loading ? 'Loading...' : 'Create account'}
            </button>
            <div className='border-t border-slate-100 pt-3 text-center text-sm'>
                <p>You already have an account? <Link to='/login' className="link">Login here</Link></p>
            </div>
        </form>
    );
};
